const COOKIE_NAME = 'dl_subscribe_dismissed';
const COOKIE_DAYS = 30;

class DlArticleSubscribeM extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.closest('.dl-article-template__subscribe');
    this.closeBtn = this.querySelector('.dl-article-template__subscribe-close');
    this.emailInput = this.querySelector('.dl-article-template__subscribe-input');
    this.submitBtn = this.querySelector('.dl-article-template__subscribe-button');
    this.messageEl = this.querySelector('.dl-article-template__subscribe-message');
    this.eventName = this.dataset.eventName;
    const configuredScrollDepth = Number.parseFloat(this.dataset.scrollDepth);
    this.scrollDepth = Number.isFinite(configuredScrollDepth)
      ? Math.min(100, Math.max(0, configuredScrollDepth))
      : 15;

    this.closeBtn?.addEventListener('click', () => this.onClose());
    this.submitBtn?.addEventListener('click', () => this.onSubmit());
    this.emailInput?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') this.onSubmit();
    });

    // 广告只是临时挡住订阅区，不能阻止订阅组件绑定事件。
    if (this.isDismissed()) {
      this.hideBlock();
      return;
    }

    this.footerStart = document.querySelector('.shopify-section-group-footer-group')
      || document.querySelector('dl-footer-signup-bar, dl-footer-h, footer');
    this._scrollHandler = this._onScroll.bind(this);
    this._resizeHandler = this.syncDisplayMode.bind(this);
    window.addEventListener('resize', this._resizeHandler, { passive: true });
    this.syncDisplayMode();
  }

  disconnectedCallback() {
    if (this._scrollHandler) {
      window.removeEventListener('scroll', this._scrollHandler);
    }
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
    if (this._footerHideTimer) {
      window.clearTimeout(this._footerHideTimer);
    }
  }

  isBottomMode() {
    return this.wrapper?.classList.contains('layout-bottom') || window.innerWidth <= 990;
  }

  syncDisplayMode() {
    const isBottomMode = this.isBottomMode();

    if (isBottomMode) {
      if (!this._isBottomMode) {
        this._isBottomMode = true;
        this.wrapper?.classList.remove('dl-show', 'dl-footer-hiding');
        window.addEventListener('scroll', this._scrollHandler, { passive: true });
      }
      this._onScroll();
      return;
    }

    if (this._isBottomMode) {
      window.removeEventListener('scroll', this._scrollHandler);
      this._isBottomMode = false;
    }

    const hasVisibleSidebarAd = this.closest('dl-article-sidebar')
      ?.querySelector('.dl-article-template__ads-sidebar.dl-show');
    if (hasVisibleSidebarAd) {
      this.hideBlockImmediately();
    } else {
      this.showBlock();
    }
  }

  _onScroll() {
    const hasReachedFooter = this.footerStart
      && this.footerStart.getBoundingClientRect().top <= window.innerHeight;
    const scrollableDistance = document.documentElement.scrollHeight - window.innerHeight;
    const scrollProgress = scrollableDistance > 0
      ? (window.scrollY / scrollableDistance) * 100
      : 0;
    const hasReachedShowPoint = scrollProgress >= this.scrollDepth;

    if (hasReachedFooter) {
      this.hideAtFooter();
    } else if (hasReachedShowPoint) {
      this.showBlock();
    } else {
      this.hideBlockImmediately();
    }
  }

  showBlock() {
    if (this._footerHideTimer) {
      window.clearTimeout(this._footerHideTimer);
      this._footerHideTimer = null;
    }
    this.wrapper?.classList.remove('dl-footer-hiding');
    this.wrapper?.classList.add('dl-show');
  }

  hideAtFooter() {
    if (!this.wrapper?.classList.contains('dl-show')
      || this.wrapper.classList.contains('dl-footer-hiding')) return;

    this.wrapper.classList.add('dl-footer-hiding');
    this._footerHideTimer = window.setTimeout(() => {
      this.wrapper?.classList.remove('dl-show', 'dl-footer-hiding');
      this._footerHideTimer = null;
    }, 450);
  }

  hideBlockImmediately() {
    if (this._footerHideTimer) {
      window.clearTimeout(this._footerHideTimer);
      this._footerHideTimer = null;
    }
    this.wrapper?.classList.remove('dl-show', 'dl-footer-hiding');
  }

  isDismissed() {
    return document.cookie.split(';').some((c) => c.trim().startsWith(`${COOKIE_NAME}=`));
  }

  setDismissedCookie() {
    const maxAge = COOKIE_DAYS * 24 * 60 * 60;
    document.cookie = `${COOKIE_NAME}=1; max-age=${maxAge}; path=/`;
  }

  hideBlock() {
    this.hideBlockImmediately();
    if (this._scrollHandler) {
      window.removeEventListener('scroll', this._scrollHandler);
      this._scrollHandler = null;
    }
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
      this._resizeHandler = null;
    }
  }

  onClose() {
    this.setDismissedCookie();
    this.hideBlock();
  }

  isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email) && email.length <= 128;
  }

  showMessage(text, isError = false) {
    if (!this.messageEl) return;
    this.messageEl.textContent = text;
    this.messageEl.className = 'dl-article-template__subscribe-message';
    this.messageEl.classList.add(
      isError
        ? 'dl-article-template__subscribe-message--error'
        : 'dl-article-template__subscribe-message--success'
    );
  }

  clearMessage() {
    if (!this.messageEl) return;
    this.messageEl.textContent = '';
    this.messageEl.className = 'dl-article-template__subscribe-message';
  }

  setLoading(loading) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = loading;
    this.submitBtn.classList.toggle('dl-article-template__subscribe-button--loading', loading);
  }

  getShopifyStore() {
    let store = localStorage.getItem('braze_lastest_shopify_store');
    if (!store) {
      let subdomain = window.location.hostname.split('.')[0];
      subdomain = subdomain === 'petlibro' || subdomain === 'ca' ? 'us' : subdomain;
      localStorage.setItem('braze_lastest_shopify_store', subdomain);
      store = subdomain;
    }
    return store;
  }

  async onSubmit() {
    const email = this.emailInput?.value?.trim();
    this.clearMessage();

    if (!email || !this.isValidEmail(email)) {
      this.showMessage(this.dataset.invalid || 'Please enter a valid email address.', true);
      return;
    }

    if (typeof braze === 'undefined' || !braze) {
      this.showMessage(this.dataset.error || 'Please try again later.', true);
      return;
    }

    this.setLoading(true);

    try {
      DLPixelH.identify(email);

      const shopifyStore = this.getShopifyStore();
      DLPixelH.capture(this.eventName, {
        email,
        source: this.dataset.source,
        shopify_store: shopifyStore,
      });

      this.emailInput.value = '';
      this.showMessage(this.dataset.success || 'Thank you for subscribing!');
      this.setDismissedCookie();
      setTimeout(() => this.hideBlock(), 3000);
    } catch (_) {
      this.showMessage(this.dataset.error || 'Please try again later.', true);
      this.setLoading(false);
    }
  }
}

customElements.define('dl-article-subscribe-m', DlArticleSubscribeM);
